module.exports = __webpack_public_path__ + "img/face.0689ce50.svg";